import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_DATABASES_LIST:
            if (!responseHelper.isGetDatabasesListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_DATABASE_LIST,
                    payload: {
                        databaseList: response.data
                    }
                }
            ];
        case handlers.GET_DATABASES_READY_FOR_PARTIAL_UPDATES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_DATABASES_READY_FOR_PARTIAL_UPDATES,
                    payload: {
                        databaseList: response.data
                    }
                }
            ];
        case handlers.SET_ACTIVE_DATABASE:
            if (response.result !== resultCodes.RESULT_OK) {
                let setDatabaseRequest = state.server.requests.find((request) => request.id === response.sequence);

                if (setDatabaseRequest.next === null) {
                    return [messageHelper.getFlashMessage(response)];
                }

                return [messageHelper.getFlashMessage(response), setDatabaseRequest.next];
            }

            return [
                {
                    type: actionTypes.DATABASE_CHANGE
                }
            ];
        case handlers.GET_COMPATIBLE_SERVERS:
            if (!responseHelper.isGetRedlikeServersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_COMPATIBLE_SERVER_LIST,
                    payload: {
                        compatibleServerList: response.data
                    }
                }
            ];
        case handlers.GET_COMPATIBLE_SERVERS_AND_OPEN_MODAL:
            if (!responseHelper.isGetRedlikeServersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_COMPATIBLE_SERVER_LIST,
                    payload: {
                        compatibleServerList: response.data
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.CREATE_ORDER_MODAL
                    }
                }
            ];
        case handlers.LIGHT_LOAD_COMPATIBLE_SERVERS:
            if (!responseHelper.isGetRedlikeServersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_COMPATIBLE_SERVER_LIST,
                    payload: {
                        compatibleServerList: response.data
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.CREATE_ORDER_MODAL
                    }
                }
            ];
        case handlers.UPDATE_DATABASES:
            if (response.result !== resultCodes.RESULT_OK) {
                if (response.result === resultCodes.RESULT_ANOTHER_UPDATE_RUNNING) {
                    return [
                        {
                            type: actionTypes.DATABASE_UPDATE_IN_PROGRESS
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.DATABASE_UPDATE_FINISHED
                    },
                    messageHelper.getFlashMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.DATABASE_UPDATE_FINISHED
                }
            ];
        case handlers.ADD_SERVER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: false,
                            activeOnly: false
                        }
                    },
                    method: handlers.GET_SERVER_MANAGEMENT_LIST,
                    tabId: 0
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_SERVER_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: true,
                            activeOnly: true,
                            orderingOnly: true
                        }
                    },
                    method: handlers.GET_COMPATIBLE_SERVERS,
                    tabId: 0
                }
            ];
        case handlers.EDIT_SERVER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: false,
                            activeOnly: false
                        }
                    },
                    method: handlers.GET_SERVER_MANAGEMENT_LIST,
                    tabId: 0
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_SERVER_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: true,
                            activeOnly: true,
                            orderingOnly: true
                        }
                    },
                    method: handlers.GET_COMPATIBLE_SERVERS,
                    tabId: 0
                }
            ];
        case handlers.DELETE_REDLIKE_SERVERS:
        case handlers.GET_SERVER_MANAGEMENT_LIST:
            if (!responseHelper.isGetRedlikeServersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SERVER_MANAGEMENT_LIST,
                    payload: {
                        serverList: response.data
                    }
                }
            ];
        case handlers.INSTALL_DATABASE_FILE_EXCEL: {
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data.warnings) {
                return [
                    {
                        type: actionTypes.SAVE_EXCEL_FILE_RESULT,
                        payload: {
                            result: response.data.warnings.length === 0,
                            log: response.data.warnings
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_EXCEL_FILE_ANALYSIS,
                    payload: {
                        stats: response.data.stats
                    }
                }
            ];
        }
        case handlers.INSTALL_DATABASE_FILE_EXE:
        case handlers.INSTALL_DATABASE_FILE_ZIP:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DATABASES_LIST,
                        params: {
                            all: true
                        }
                    },
                    method: handlers.GET_ALL_DATABASES_LIST,
                    tabId: 0
                }
            ];
        case handlers.SET_CLIENT_IDENTIFIER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CLIENT_IDENTIFIER
                    },
                    method: handlers.GET_CLIENT_IDENTIFIER,
                    tabId: 0
                }
            ];
        case handlers.GET_CLIENT_IDENTIFIER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SET_CLIENT_IDENTIFIER,
                    payload: {
                        clientIdentifier: response.data
                    }
                }
            ];
        case handlers.UNLOCK_COMPUTER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_REDLIKE_WINDOW
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
